import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {SharedModule} from 'shared/shared.module';
import {CommonSharedModule} from '@modules/activities/core/shared-components/common-shared.module';
import {FuseSharedModule} from 'fuse-core/shared.module';
import {ActivitiesCardModule} from '@modules/activities/core/shared-components/card/activities-card.module';

@NgModule({
    imports: [
        CommonModule,
        FuseSharedModule,
        SharedModule,
        CommonSharedModule,
        ActivitiesCardModule,
        MatButtonToggleModule
    ],
    exports: [
        FuseSharedModule,
        SharedModule,
        CommonSharedModule,
        ActivitiesCardModule
    ],
})
export class ActivitiesSharedModule {
}
